// extracted by mini-css-extract-plugin
module.exports = {"palette":"NodePalette_palette__Uivwn","palette__item":"NodePalette_palette__item__3HjXR"};